import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BlankComponent } from './layouts/blank/blank.component';
import { FullComponent } from './layouts/full/full.component';

import { AuthGuard } from './guards/auth/auth.guard';
import { PermissionGuard } from './guards/permission.guard';




const routes: Routes = [
  {
    path: '',
    component: FullComponent,
    children: [
      {
        path: '',
        redirectTo: '/dashboards/dashboard1',
        pathMatch: 'full',
      },
      {
        path: 'starter',
        loadChildren: () =>
          import('./pages/pages.module').then((m) => m.PagesModule),
      },
      {
        path: 'dashboards',
        loadChildren: () =>
          import('./pages/dashboards/dashboards.module').then(
            (m) => m.DashboardsModule
          ),
      },
      {
        path: 'mforms',
        loadChildren: () =>
          import('./pages/mforms/mforms.module').then(
            (m) => m.MformsModule
          ),
      },
      {
        path: 'goals',
        loadChildren: () =>
          import('./pages/goals/goals.module').then(
            (m) => m.GoalsModule
          ),
        canActivate: [PermissionGuard],
        data: { moduleCode: 'goals' }
      },
      {
        path: 'goals-report',
        loadChildren: () =>
          import('./pages/goals-report/goals-report.module').then(
            (m) => m.GoalsReportModule
          ),
        canActivate: [PermissionGuard],
        data: { moduleCode: 'goals-report' }
      },
      {
        path: 'products',
        loadChildren: () =>
          import('./pages/products/products.module').then(
            (m) => m.ProductsModule
          ),
        canActivate: [PermissionGuard],
        data: { moduleCode: 'products' }
      },
      {
        path: 'presupuesto',
        loadChildren: () =>
          import('./pages/presupuesto/presupuesto.module').then(
            (m) => m.PresupuestoModule
          ),
        canActivate: [PermissionGuard],
        data: { moduleCode: 'presupuesto' }
      },
      {
        path: 'estado-de-resultados',
        loadChildren: () =>
          import('./pages/estado-de-resultados/estado-de-resultados.module').then(
            (m) => m.EstadoDeResultadosModule
          ),
        canActivate: [PermissionGuard],
        data: { moduleCode: 'estado-de-resultados' }
      },
      {
        path: 'acumulado-ventas-vendedor',
        loadChildren: () =>
          import('./pages/acumulado-ventas-vendedor/acumulado-ventas-vendedor.module').then(
            (m) => m.AcumuladoVentasVendedorModule
          ),
        canActivate: [PermissionGuard],
        data: { moduleCode: 'acumulado-ventas-vendedor' }
      },
      {
        path: 'security',
        loadChildren: () =>
          import('./pages/security/security.module').then(
            (m) => m.SecurityModule
          )
      },
      {
        path: 'hr',
        loadChildren: () =>
          import('./pages/hr/hr.module').then(
            (m) => m.HrModule
          ),
        canActivate: [PermissionGuard],
        data: { moduleCode: 'hr' }
      },
      {
        path: 'reports',
        loadChildren: () =>
          import('./pages/reports/reports.module').then(
            (m) => m.ReportsModule
          ),
        canActivate: [PermissionGuard],
        data: { moduleCode: 'reports' }
      },

    ],
    canActivate: [AuthGuard]
  },
  {
    path: '',
    component: BlankComponent,
    children: [
      {
        path: 'authentication',
        loadChildren: () =>
          import('./pages/authentication/authentication.module').then(
            (m) => m.AuthenticationModule
          ),
      },
    ],
  },
  {
    path: '**',
    redirectTo: 'authentication/error',
  },

];

@NgModule({
  imports: [
    RouterModule.forRoot(routes),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}

// Instrucciones detalladas para agregar nuevas rutas:
/*
  Importante
  Para que el componente este contenido dentro del diseño del template debe agregarse dentro de la lista children de la primer ruta
  de lo contrario no contendra el diseño del navbar ni el sidebar

  1. Importar el componente que quieres asociar a la nueva ruta:
     import { NewComponent } from './path/to/new-component/new-component.component';

  2. Agregar una nueva entrada en el arreglo `routes`:
     {
       path: 'new-path', // Define la nueva ruta
       component: NewComponent, // Asocia el componente importado a esta ruta
       canActivate: [AuthGuard] // (Opcional) Añade guardias de autenticacion a la ruta si es necesario
     }

  3. Asegúrate de que la ruta del componente sea correcta y que el componente esté declarado en algún módulo.

  4. (Opcional) Si necesitas proteger la nueva ruta con un guard, asegúrate de que el guard esté correctamente implementado e importado:
     import { AuthGuard } from './guards/auth.guard';

  5. Si usas Lazy Loading para módulos, puedes configurar la ruta así:
     {
       path: 'new-path',
       loadChildren: () => import('./path/to/new-module/new-module.module').then(m => m.NewModule)
     }

  6. Después de agregar la nueva ruta, asegúrate de actualizar el menú de navegación o cualquier enlace que haga referencia a esta nueva ruta.
*/

//
/*

*/
